import { useAction, useAtom } from "@reatom/npm-react";
import { memo, useCallback } from "react";
import { useGravityDevice } from "src/hooks/useGravityDevice";

import { ExportLogsModal, ExportLogsSheet } from "./components";
import { useJobMetadata } from "./hooks";
import { exportLogsModalAtom, selectJobAtom } from "./store/atoms";

export const ResponsiveExportLogsWidget = memo(() => {
  const { isMobile } = useGravityDevice();

  const [isOpen] = useAtom(exportLogsModalAtom);
  const toggleOpen = useAction(exportLogsModalAtom.toggle);
  const [job, setJob] = useAtom(selectJobAtom);

  const metadata = useJobMetadata(job);

  const onClose = useCallback(() => {
    toggleOpen();
    setJob(null);
  }, [setJob, toggleOpen]);

  if (isMobile) {
    return (
      <ExportLogsSheet
        open={isOpen}
        onClose={onClose}
        job={job}
        metadata={metadata}
      />
    );
  }
  return (
    <ExportLogsModal
      open={isOpen}
      onClose={onClose}
      job={job}
      metadata={metadata}
    />
  );
});

ResponsiveExportLogsWidget.displayName = "ResponsiveExportLogsWidget";
